import { render, staticRenderFns } from "./FixedBenefits.vue?vue&type=template&id=4bacd812&"
import script from "./FixedBenefits.vue?vue&type=script&lang=js&"
export * from "./FixedBenefits.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports